
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {Link} from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Zu den Traumklassikern gehört – natürlich – das Thema Sex. Zusammen mit Träumen vom freien Fall, vom Nacktsein in der Öffentlichkeit oder von der Erfahrung, etwas immer wieder vergeblich zu versuchen. `}<M mdxType="M">{`Am allermeisten träumen Menschen weltweit aber von Verfolgungsjagden.`}</M>{` Unabhängig von Alter, Nationalität, Geschlecht und Kultur. An zweiter Stelle folgt die Angst, Prüfungen nicht zu bestehen. Was in den Listen mit Top-Traumthemen nicht erwähnt wird, sind hingegen die vielen Träume, an die wir uns nicht erinnern können. Und die sind in der Regel weitaus banaler. `}</p>
    <p>{`Der Schlafforscher Albrecht Vorster schreibt in seinem Buch «Warum wir schlafen», dass wir in den meisten Nächten von ganz alltäglichen Dingen träumen: von Erlebnissen mit Freunden, von Familienmitgliedern, dem Hund oder der Chefin. `}<M mdxType="M">{`Dass viele Träumer das Gefühl hätten, dass ihre Träume bizarr seien, liege darin, dass wir die banalen Traumerlebnisse schlicht vergessen haben.`}</M>{` Übrigens: Um die Häufigkeit von Träumen zu ermitteln, greifen Schlafforscher noch heute auf den von kanadischen Psychologen erweiterten Fragebogen aus den 1990er-Jahren zurück – den `}<Link href='http://dreamscience.ca/en/documents/publications/_2003_Nielsen_Reprint_D_13_211-235_TDQ.pdf#page=25' mdxType="Link">{`«Typical Dreams Questionnaire»`}</Link>{`. Darin werden 55 Traumthemen behandelt. So entstehen riesige Datenbanken von Träumen, die weltweit miteinander verglichen werden können. `}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;